<template>
  <div class="step-two">
    <div class="step-two__wrapper">
      <InsuranceTariffsList
        class="step-two__cards"
        :tariffs-sum="tariffsSum"
        :form-data="formData"
        @tariff-chosen="handleTariff"
        @mounted="mountedHandler"
      />
    </div>
  </div>
</template>

<script>
import InsuranceTariffsList from '@/components/pages/index/InsuranceProcess/InsuranceTariffsList';
import ResultCard from '@/components/pages/index/InsuranceProcess/ResultCard';
import BaseButton from "@/components/ui/BaseButton.vue";

export default {
  name: 'Step2',
  components: {
    BaseButton,
    ResultCard,
    InsuranceTariffsList
  },
  props: {
    tariffsSum: Object,
    formData: Object,
    discountPercent: Number,
  },
  data() {
    return {
      tariffs: [],
    }
  },
  computed: {

  },
  methods: {
    mountedHandler(tariffs) {
      this.$emit('mounted', tariffs)
    },
    handleTariff(tariffs) {
      this.$emit('tariff-chosen', tariffs)
    },
  },
}
</script>
<style scoped lang="scss">
.step-two {
  &__wrapper {
    &:not(:last-child) {
      margin-bottom: rem(32);
    }
  }

  &__result {
    height: 100%;
  }
}
</style>
